import { useState, useEffect } from "react";

export const useLocalStorage = <T>(key: string, defaultValue?: T) => {
  // Start with default value to avoid hydration mismatch
  const [value, setValue] = useState<T | undefined>(defaultValue);
  const [isHydrated, setIsHydrated] = useState(false);

  // Read from localStorage only after hydration
  useEffect(() => {
    if (typeof window !== 'undefined') {
      try {
        const item = localStorage.getItem(key);
        const currentValue = item !== null ? JSON.parse(item) : defaultValue;
        setValue(currentValue);
      } catch (error) {
        console.warn('Failed to read from localStorage:', error);
        setValue(defaultValue);
      }
      setIsHydrated(true);
    }
  }, [key, defaultValue]); // Include dependencies

  // Write to localStorage when value changes (after hydration)
  useEffect(() => {
    if (isHydrated && value !== undefined) {
      try {
        localStorage.setItem(key, JSON.stringify(value));
      } catch (error) {
        console.warn('Failed to save to localStorage:', error);
      }
    }
  }, [value, key, isHydrated]);

  return [value, setValue] as const;
};
